import { Link } from "react-router-dom";
import * as React from 'react';
import type { States } from '@@services/services';
import type { Entities } from '@inwink/entities/entities';
import { BurgerMenu } from './ui/burgermenu';
import { Swipeable } from './ui/swipeable';
import { connectwith } from "@inwink/react-utils/decorators/connectwith";
import { AppShellMenuContext, IAppShellMenuState } from "./appshellmenucontext";
import { IMegaMenuDataContext, MegaMenuContext } from "./megamenu/megamenudata";
import { MegaMenuRoot } from "./megamenu/megamenuroot";

import './appmenu.less';
import { AppCommandPromptRegistration, IAppCommandPromptRegistration } from "./appcommandprompt/appcommandpromptregistration";
import { MegaMenuAppCommand } from "./megamenu/megamenuappcommand";
import { withI18nHelper } from "@inwink/i18n";
import { menuSearchCommand } from "./appcommandprompt/appcommandpromptcontext";

export interface IAppMenuProps {
    customer: States.ICustomerState;
    event: States.IEventState;
    community?: States.ICommunityState;
    user: States.IAppUserState;
    i18n: States.i18nState;
    i18nHelper?: Entities.i18nHelper;
    rights: States.IAppUserRights;
    menuItemClicked?: () => void;
    isMobile: boolean;
}

interface IAppMenuState {
    command?: IAppCommandPromptRegistration;
}

function mapStateToProps(state: States.IAppState) {
    return {
        community: state.community,
        event: state.event,
        user: state.user,
        customer: state.customer
        //appmenu: state.appmenu
    };
}

export function AppMenu(props: IAppMenuProps) {
    const menuContext = React.useContext(AppShellMenuContext);
    const megaMenuContext = React.useContext(MegaMenuContext);
    return <AppMenuContent {...props} menuState={menuContext} megaMenu={megaMenuContext} />;
}

@withI18nHelper()
@connectwith(mapStateToProps, null)
class AppMenuContent extends React.PureComponent<
    IAppMenuProps & { menuState: IAppShellMenuState, megaMenu: IMegaMenuDataContext }, IAppMenuState> {
    constructor(props) {
        super(props);
        this.state = {
            command: this.getMenuCommand()
        };
    }

    getMenuCommand() {
        if (this.props.megaMenu?.config) {

            return {
                trigger: menuSearchCommand,
                providers: [new MegaMenuAppCommand(this.props.megaMenu?.config, () => {
                    return {
                        i18nHelper: this.props.i18nHelper,
                        match: this.props.megaMenu.match
                    };
                })]
            };
        }
        return null;
    }

    componentDidUpdate(prevProps: Readonly<IAppMenuProps & { menuState: IAppShellMenuState, megaMenu: IMegaMenuDataContext }>) {
        if (prevProps.megaMenu !== this.props.megaMenu) {
            this.setState({
                command: this.getMenuCommand()
            });
        }
    }

    toggleMenu = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        this.props.menuState.toggleMenu();
    };

    menuItemClicked = () => {
        if (!this.props.menuState.allowFixed && !this.props.menuState.collapsed) {
            this.props.menuState.toggleMenu();
        }
    };

    menuEntryClicked = () => {
        if (this.props.menuState.collapsed) {
            this.props.menuState.toggleMenu();
        }
    };

    onSwiped = () => {
        this.props.menuState.toggleMenu();
    };

    render() {
        const i18nHelper = this.props.i18nHelper;
        const persistMode = this.props.megaMenu && !this.props.isMobile;
        const menucontent = <div className="appmenu-content">
            <header>
                <Link to="/">
                    <img alt="inwink" src={(inwink.config.assetsUrl || "/") + "assets/inwink/LOGO_WHITE_RGB.svg"} />
                    {/* {inwink.config.env && inwink.config.env !== "prod"
                        ? <span className="env">{inwink.config.env.replace("env-", "")}</span>
                        : null} */}
                </Link>
                <BurgerMenu collapsed={true} allowAnimation={true}
                    displayArrow={persistMode}
                    title={i18nHelper.translate(!this.props.menuState.collapsed ? "actions.collapse" : "actions.expand")}
                    onClick={(arg) => {
                        arg.preventDefault();
                        arg.stopPropagation();
                        this.props.menuState.toggleMenu(persistMode);
                    }} />
            </header>
            <section>
                {this.props.megaMenu ? <MegaMenuRoot
                    {...this.props}
                    key={this.props.megaMenu?.key || "empty"}
                    menuContext={this.props.megaMenu}
                    onMenuItemClicked={this.menuItemClicked}
                    onMenuEntryClicked={this.menuEntryClicked}
                    match={this.props.megaMenu.match} /> : null}
            </section>
            {/* <footer>
                {this.props.megaMenu && !this.props.isMobile ?
                    <button
                        title={i18nHelper.translate(!this.props.menuState.collapsed ? "actions.collapse" : "actions.expand")}
                        onClick={() => {
                            this.props.menuState.toggleMenu(true);
                        }}><i className="inwinkbo-double-chevron-left" /></button> : null}
            </footer> */}
        </div>;

        if (this.props.isMobile) {
            return <>
                <div className="appmenu-overlay" onClick={this.toggleMenu} />
                <div className="appmenu">
                    <Swipeable
                        className="appmenu-swipe"
                        behavior="slide"
                        disableRight
                        selectThresholdPx={60}
                        onChangeIndex={this.onSwiped}
                    >
                        {menucontent}
                    </Swipeable>
                </div>
            </>;
        }
        return <AppCommandPromptRegistration registration={this.state.command}>
            <div className="appmenu-overlay" onClick={this.toggleMenu} />
            <div className="appmenu">
                {menucontent}
            </div>
        </AppCommandPromptRegistration>;
    }
}

export default AppMenu;